<!--
  Modified by Justin Jäger for the Unfolded.Tools Remote Simulator.
  Modified build first published: 2026-08-03.
  Licensed as part of the modified Web Configurator under GNU GPL v3.0 only.
  See MODIFICATIONS.md for details.
-->
<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import type { IntegrationStatus } from "@/types/integrationInstance";
import { integrationsStore } from "@/stores/integrations";
import { addErrorBottom } from "@/stores/messages";
import { searchLanguageText } from "@/composables/translatedProperty";
import IntegrationListItem from "@/components/integration/IntegrationListItem.vue";
const store = integrationsStore();
const { statuses } = storeToRefs(store);
const props = defineProps({ searchText: { type: String, default: "" } });
const loading = ref(false);
defineExpose({ loadData });
const filteredInstanceList = computed<IntegrationStatus[]>(() => { const search = props.searchText.toLowerCase(); return statuses.value.filter((item) => searchLanguageText(item.name, search) || (item.integration_id || "").toLowerCase().includes(search) || item.driver_id?.toLowerCase().includes(search)); });
async function loadData() { try { await store.getStatuses(true); } catch (error) { addErrorBottom(error); } }
onMounted(async () => { loading.value = true; await loadData(); loading.value = false; });
</script>
<template>
  <div class="integration-list"><div class="integration-list__body"><div class="ent-list">
    <div v-if="filteredInstanceList.length > 0" v-overflow-indicator class="ent-list__body-wrapper"><div class="ent-list__body"><IntegrationListItem v-for="inst in filteredInstanceList" :key="inst.integration_id" :integration="inst" /></div></div>
    <p v-if="statuses.length < 1 && !loading" class="ent-list__description">{{ $t("integration.no_integrations") }}</p>
    <p v-else-if="filteredInstanceList.length < 1 && !loading" class="ent-list__description">{{ $t("ui.nothing_was_found") }}</p>
  </div></div></div>
</template>
